// @flow
import React, { Component } from 'react'
import { translations, translateFunc } from '../shared/localize'
import Form from './Replenishment/Form'
import Recommendations from './Replenishment/Recommendations'
import Switcher from './controls/Switcher'

type Props = {|
  accountId: number,
  replenishmentCommission: number,
  currency: string,
  showRecommendations: boolean,
  roboWeekAmount: number,
  roboMonthAmount: number,
  roboMinValuableAmount: number,
  roboUrl: string,
  bankWeekAmount: number,
  bankMonthAmount: number,
  bankMinValuableAmount: number,
  bankUrl: string
|}

type State = {|
  tab: string,
  value: string
|}

export default class Replenishment extends Component<Props, State> {
  t: Function

  constructor(props: Props) {
    super(props)

    this.t = translateFunc(translations.replenishment)

    this.state = { tab: 'bank', value: '' }
  }

  render() {
    const {
      roboMinValuableAmount,
      bankMinValuableAmount,
      roboWeekAmount,
      bankWeekAmount,
      roboMonthAmount,
      bankMonthAmount,
      replenishmentCommission,
      showRecommendations,
      roboUrl,
      bankUrl,
      currency,
      accountId
    } = this.props
    const { tab, value } = this.state
    const robo = tab === 'robo'
    const minValuableAmount = robo ? roboMinValuableAmount : bankMinValuableAmount
    let recommendationHint = this.t(robo ? 'min_amount_robokassa' : 'min_amount_bank', {
      amount: minValuableAmount
    })
    if (replenishmentCommission !== 0)
      recommendationHint +=
        '. ' + this.t('commission_comment', { commission: replenishmentCommission * 100 })

    return (
      <div>
        <Switcher
          options={[
            { name: this.t('bank_replenish'), id: 'bank' },
            { name: this.t('robo_replenish'), id: 'robo' }
          ]}
          value={tab}
          onChange={(value) => this.setState({ tab: value })}
        />
        <Recommendations
          minValuableAmount={minValuableAmount}
          weekAmount={robo ? roboWeekAmount : bankWeekAmount}
          monthAmount={robo ? roboMonthAmount : bankMonthAmount}
          hint={recommendationHint}
          showValues={showRecommendations}
          onRecommendation={(value) => this.valueChanged(value.toString())}
        />
        <Form
          replenishmentCommission={replenishmentCommission}
          url={robo ? roboUrl : bankUrl}
          currency={currency}
          accountId={accountId}
          value={value}
          onChange={(value) => this.valueChanged(value)}
        />
      </div>
    )
  }

  valueChanged(value: string) {
    if (value.length > 10) {
      value = this.state.value
    } else {
      value = value.replace(/[^0-9]/, '')
      if (value.length > 0) value = parseInt(value).toString()
    }

    this.setState({ value })
  }
}
